import { vuexHandbookPage } from '@/store/composition/page/handbookPage'
import { PTO_HANDBOOK_MEASURE_UNIT_URL } from '@/api/pto/handbook'

const state = () => ({
  ...vuexHandbookPage.createState(),
  urlApi: PTO_HANDBOOK_MEASURE_UNIT_URL
})

const getters = {
  ...vuexHandbookPage.createGetters()
}

const mutations = {
  ...vuexHandbookPage.createMutations()
}

const actions = {
  ...vuexHandbookPage.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
